import { SignInWithJCOSType } from 'client/util/Constants';
import DevicesApi from 'client/api/v2/DevicesApi';
import LocalStorageConsts from 'client/util/Constants/LocalStorageConstants';
import LocalStorageService from 'client/util/LocalStorageService';
import Vue from 'vue';
import createModel from 'client/store/modules/models/createModel';

const defaultSettings = [
  {
    osFamily: SignInWithJCOSType.windows,
    enabled: false,
    defaultPermission: SignInWithJCOSType.standard,
  },
  {
    osFamily: SignInWithJCOSType.macOS,
    enabled: false,
    defaultPermission: SignInWithJCOSType.standard,
  },
];

export const getDefaultItem = () => ({
  devicesLocalStorageSettings: {
    deviceListHomePage: false,
  },
  organizationObjectId: '',
  // Note: order of settings array not guaranteed
  settings: defaultSettings,
});

const model = createModel(getDefaultItem, 'id', DevicesApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    handleToggleLocalStorageValueAction(context, payload) {
      context.dispatch('setItemField', { key: 'devicesLocalStorageSettings', value: { deviceListHomePage: payload } });
    },

    async fetchItem(context, hasFeatureFlag) {
      const response = hasFeatureFlag
        ? await DevicesApi.fetchSignInWithJCSettings()
        : Promise.resolve({ data: {} });
      const localStorage = JSON.parse(LocalStorageService.getValue(
        LocalStorageConsts.devicesMainPanelLandingTab,
      )) || {
        deviceListHomePage: false,
      };

      if (hasFeatureFlag) {
        let { settings } = response.data;
        if (settings.length === 1) {
          if (settings.findIndex((obj) => obj.osFamily === SignInWithJCOSType.windows) >= 0) {
            settings.push(defaultSettings[1]);
          } else {
            settings.push(defaultSettings[0]);
          }
        }
        settings = settings.length === 0 ? defaultSettings : settings;
        response.data.settings = settings;
      }

      context.dispatch('setItemField', { key: 'devicesLocalStorageSettings', value: localStorage });
      context.commit('SET_ITEM', response.data);
      context.dispatch('setPreviousItemField', { key: 'devicesLocalStorageSettings', value: localStorage });
      context.commit('SET_PREVIOUS_ITEM', response.data);
    },
    resetToggle(context, os) {
      context.commit('RESET_TOGGLE', os);
    },
    async saveItem(context, payload) {
      const { devicesLocalStorageSettings, hasFeatureFlag, ...rest } = payload;
      LocalStorageService.setItem(
        LocalStorageConsts.devicesMainPanelLandingTab,
        JSON.stringify(devicesLocalStorageSettings),
      );
      return hasFeatureFlag
        ? DevicesApi.updateSignInWithJCSettings(rest)
        : Promise.resolve({ data: {} });
    },
  },

  getters: {
    ...model.getters,
    getDeviceListToggleValue(state) {
      return state.item.devicesLocalStorageSettings.deviceListHomePage;
    },
    getisMacOSEnabled(state) {
      const { settings } = state.item;
      const index = settings.findIndex((obj) => obj.osFamily === SignInWithJCOSType.macOS);
      return !!state.item.settings[index]?.enabled;
    },
    getisWindowsEnabled(state) {
      const { settings } = state.item;
      const index = settings.findIndex((obj) => obj.osFamily === SignInWithJCOSType.windows);
      return !!state.item.settings[index]?.enabled;
    },
  },
  mutations: {
    ...model.mutations,
    RESET_TOGGLE(state, os) {
      // eslint-disable-next-line no-param-reassign
      const newSettings = [...state.item.settings];
      const indexToFind = newSettings.findIndex((obj) => obj.osFamily === os);
      newSettings.splice(indexToFind, 1, {
        ...state.item.settings[indexToFind],
        enabled: false,
      });
      Vue.set(state.item, 'settings', newSettings);
    },
  },

};
